module.exports = __webpack_public_path__ + "img/shoe2.bfd412ac.png";